import { render, staticRenderFns } from "./LinkFormDataTable.vue?vue&type=template&id=17f88e79&"
import script from "./LinkFormDataTable.vue?vue&type=script&lang=js&"
export * from "./LinkFormDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports